import { goRequest } from '../utils/httpClientTs';
import { ReportOption } from '../types/reports';

/**
 * Get all reports for selectors (permissions management, document type/category)
 * Returns all reports from peo_reports table
 */
export const getAllReports = (): Promise<ReportOption[]> =>
  goRequest<ReportOption[]>({
    url: '/api/reports/list/all',
    method: 'GET',
  });
